import { Card } from 'baseui/card'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import { Button, KIND, SIZE, SHAPE } from 'baseui/button'
import { Spinner } from 'baseui/spinner'
import LogoHOP from '@/shared/icons/LogoHOP'
import useLoginStyles from '@/containers/Login/useLoginStyles'
import { applicationCountries } from '@/shared/tools/applicationCountries'
import useExperimentalSsoLogin from './useExperimentalSsoLogin'

const DISMISSED_MOMENTS = ['skipped', 'dismissed']

const ExperimentalSsoLogin = () => {
  const { country, error, isLoading, promptStatus, setCountry } = useExperimentalSsoLogin()
  const { loginWrapper, loginCard, logo, cardOverrides } = useLoginStyles()
  const isDismissed = DISMISSED_MOMENTS.includes(promptStatus) || promptStatus === 'failed'

  return (
    <div className={loginWrapper}>
      <main id='main'>
        <section>
          <div className='global-container'>
            <Card className={loginCard} overrides={cardOverrides}>
              <div className={logo}>
                <LogoHOP size={50} />
              </div>

              <p>Sign in with the Google card. No window opens and this page is never left.</p>

              <div>
                {Object.entries(applicationCountries).map(([countryCode, flag]) => (
                  <Button
                    key={countryCode}
                    isSelected={country === countryCode}
                    size={SIZE.mini}
                    kind={KIND.secondary}
                    shape={SHAPE.circle}
                    onClick={() => setCountry(countryCode)}
                    overrides={{
                      BaseButton: {
                        style: {
                          marginRight: '0.25rem',
                        },
                      },
                    }}
                  >
                    <span>{flag}</span>
                  </Button>
                ))}
              </div>

              {isLoading && <Spinner />}

              {isDismissed && (
                <Notification kind={NOTIFICATION_KIND.warning}>
                  Google did not show the card. Reload the page to ask for it again, or use /login.
                </Notification>
              )}

              {error && <Notification kind={NOTIFICATION_KIND.negative}>{error}</Notification>}
            </Card>
          </div>
        </section>
      </main>
    </div>
  )
}

export default ExperimentalSsoLogin
